<template>
  <div class="footer">
    <p class="about"><span class="f-size-14 crr"></span><span class="f-size-14 crr"></span><span class="f-size-14 crr"></span></p>
    <p class="f-size-14">ICP备案编号：陕ICP备2024037097号-3</p>
    <p><span class="f-size-14 crr"></span><span class="f-size-14 crr">版权所有：AI食育师</span><span class="f-size-14">技术支持：陕西师范大学</span></p>
    <p class="f-size-14">为了达到最好效果，推荐使用 360极速浏览器 或 谷歌浏览器</p>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.footer{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 167px;
  box-sizing: border-box;
  background: #FAFAFC;
  p{
    text-align: center;
  }
  .about{
    padding: 18px;
    /* border-bottom: 1px solid #999;
    margin-bottom: 18px; */
  }
  span{
    margin: 0 4px;
  }
}
</style>
